import ArduPilot from './ArduPilot';
import PX4 from './PX4';

import { deepCopy } from '@/utils/ObjectUtils';

const converter = { ArduPilot, PX4 };

export default converter;

export const getCommandForSurveySegment = (command) => {
  if (command.type === 'cusSurvey' && command.data.segment) {
    const newCommand = deepCopy(command);

    // TODO: Binary Search 이용한 성능 개선
    newCommand.data.positions = command.data.positions.filter(({ segment }) => {
      return segment === command.data.segment.index;
    });
    return newCommand;
  }

  return command;
};
